// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c451cf22","455":"3027d479"}[chunkId] + ".chunk.js";
};